import {
  AfterContentInit,
  Component,
  ComponentFactoryResolver,
  ContentChildren,
  HostListener,
  OnChanges,
  OnInit,
  QueryList,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { MyTabComponent } from "../my-tab/my-tab.component";
import {
  ExplorerService,
  TabConfig,
} from "@app/modules/shared/services/explorer.service";
import { KlSweetAlertService } from "@app/modules/shared/services/message/kl-sweet-alert.service";
import { TranslateService } from "@app/modules/shared/services/translate/translate.service";
import { findIndex } from "lodash";
import { UtilService } from "@app/modules/shared/services/util.service";
import * as Draggabilly from "draggabilly";
@Component({
  selector: "my-tabs",
  templateUrl: "./my-tabs.component.html",
  styleUrls: ["./my-tabs.component.scss"],
})
export class MyTabsComponent implements AfterContentInit, OnInit, OnChanges {
  draggabillyInstances = [];
  showHoverTitle = false;
  tabTitle = "";
  tabMode = "";
  hoverTimeout: any;
  tabHoverTitlePositions = {
    left: 0,
    top: "0px",
  };
  public dynamicTabs: MyTabComponent[] = [];
  @ContentChildren(MyTabComponent) tabs: QueryList<MyTabComponent>;
  @ViewChild("container", { read: ViewContainerRef, static: true })
  dynamicTabPlaceholder;
  public activeTab: any;

  TAB_CONTENT_MARGIN = 5;
  TAB_CONTENT_OVERLAP_DISTANCE = 1;
  TAB_CONTENT_MIN_WIDTH = 24;
  TAB_CONTENT_MAX_WIDTH = 195;
  TAB_SIZE_SMALL = 84;
  TAB_SIZE_SMALLER = 60;
  TAB_SIZE_MINI = 48;
  chromeElement: any;
  styleEl: any;
  isDragging = false;
  draggabillyDragging: any;

  closeType = "ALL";
  currentTab: MyTabComponent;
  currentTabIndex = 0;
  deletingTabCount = 0;
  mustClosedTabCount = 0;
  tabCountBeforeClosing = 0;
  contextMenuX = 0;
  contextMenuY = 0;
  showContextMenu = false;
  stopDeleting = false;

  noop: () => {};

  static dynamicTabIndexChange(array, old_index, new_index) {
    if (new_index >= array.length) {
      let i = new_index - array.length + 1;
      while (i--) {
        array.push(undefined);
      }
    }
    array.splice(new_index, 0, array.splice(old_index, 1)[0]);
    return array;
  }

  constructor(
    private _componentFactoryResolver: ComponentFactoryResolver,
    private explorer: ExplorerService,
    private translateService: TranslateService,
    private utilService: UtilService,
    private klSweetAlert: KlSweetAlertService
  ) {
    explorer.closeEvent$.subscribe((tab) => {
      if (typeof tab === "string") {
        this.closeWithTabId(tab);
      }
    });
    explorer.formChangeStatus$.subscribe((event) => {
      this.dynamicTabs.forEach((tab) => {
        if (tab.tabId === event.tabId) {
          tab.changeForm = event.changeForm;
        }
      });
    });
    explorer.tabStream$.subscribe((tabConfig) => {
      this.openTab(tabConfig as TabConfig);
    });
    explorer.closeAllTabEvent$.subscribe(() => {
      this.checkChangedFormCount();
    });
  }

  ngOnInit() {
    this.chromeElement = document.querySelector(".chrome-tabs");
    this.chromeElement.setAttribute("data-chrome-tabs-instance-id", "0");
    this.setupCustomProperties();
    this.setupStyleEl();
    this.layoutTabs();
    this.setupDraggabilly();
  }

  ngOnChanges() {}

  ngAfterContentInit() {
    // get all active tabs
    const activeTabs = this.tabs.filter((tab) => tab.active);
    // if there is no active tab set, activate the first
    if (activeTabs.length === 0) {
      this.selectTab(this.tabs.first);
    }
  }

  closest(value, array) {
    let closest = Infinity;
    let closestIndex = -1;

    array.forEach((v, i) => {
      if (Math.abs(value - v) < closest) {
        closest = Math.abs(value - v);
        closestIndex = i;
      }
    });

    return closestIndex;
  }

  contextmenu(event: any, currentTab: MyTabComponent) {
    event.preventDefault();
    this.currentTab = currentTab;
    this.currentTabIndex = findIndex(this.dynamicTabs, {
      tabId: currentTab.tabId,
    });
    if (window.innerWidth > 350) {
      if (window.innerWidth - event.clientX < 190) {
        this.contextMenuX = window.innerWidth - 200;
      } else {
        this.contextMenuX = event.clientX;
      }
      this.contextMenuY = event.clientY;
      this.showContextMenu = true;
    }
  }

  mouseUp(event, tab) {
    if (event.button === 1) {
      this.closeTab(tab);
    }
  }

  mouseEnter(event: MouseEvent, tab) {
    this.tabTitle = tab.title;
    this.tabMode = tab.childTemplate ? tab.childTemplate.mode : "";
    this.showHoverTitle = true;
    let chromeTabWidth = 0;
    const chromeTab = <HTMLElement>document.querySelector(".chrome-tab");
    if (chromeTab) {
      chromeTabWidth = chromeTab.offsetWidth;
    }
    const diffMouseX = event.clientX - event.offsetX;
    const index = findIndex(this.dynamicTabs, { tabId: tab.tabId });
    const left = index !== -1 ? diffMouseX + chromeTabWidth / 2 : event.clientX;
    this.tabHoverTitlePositions = {
      left: left,
      top: "7px",
    };
    this.hoverTimeout = setTimeout(() => {
      this.showHoverTitle = false;
    }, 4000);
  }

  mouseLeave() {
    clearTimeout(this.hoverTimeout);
    this.showHoverTitle = false;
    this.tabHoverTitlePositions = {
      left: 0,
      top: "",
    };
    this.tabTitle = "";
  }

  openTab(tabConfig: TabConfig) {
    const componentFactory =
      this._componentFactoryResolver.resolveComponentFactory(MyTabComponent);
    const viewContainerRef = this.dynamicTabPlaceholder;
    let sequence = 0;
    let singularityCheck = true;
    for (let i = 0; i < this.dynamicTabs.length; i++) {
      if (tabConfig.id === this.dynamicTabs[i].tabId) {
        singularityCheck = false;
        sequence = i;
      }
    }
    if (singularityCheck === true) {
      try {
        const componentRef = viewContainerRef.createComponent(componentFactory);
        const instance: MyTabComponent =
          componentRef.instance as MyTabComponent;
        instance.tabId = tabConfig.id;
        instance.changeForm = false;
        instance.title = tabConfig.title;
        instance.isCloseable = tabConfig.isCloseable;
        instance.childTemplate = tabConfig.childTemplate;
        this.dynamicTabs.push(instance as MyTabComponent);
        setTimeout(() => {
          this.addTab(tabConfig.id);
        }, 300);
        this.selectTab(this.dynamicTabs[this.dynamicTabs.length - 1]);
        setTimeout(() => {
          this.layoutTabs();
          // this.fixZIndexes();
          this.setupDraggabilly();
        }, 10);
      } catch (error) {
        throw Error(error);
      }
    } else {
      this.selectTab(this.dynamicTabs[sequence]);
      this.layoutTabs();
      // this.fixZIndexes();
      this.setupDraggabilly();
    }
  }

  selectTab(tab: MyTabComponent) {
    this.activeTab = tab;
    this.tabs.toArray().forEach((t) => (t.active = false));
    this.dynamicTabs.forEach((t) => (t.active = false));
    tab.active = true;
    const tabEl = document.getElementById(tab.tabId);
    this.setCurrentTab(tabEl);
    setTimeout(() => {
      this.layoutTabs();
      this.explorer.menuCollapse();
    }, 1);
  }

  closeWithTabId(tabId) {
    this.dynamicTabs.forEach((tab) => {
      if (tab.tabId === tabId) {
        this.closeTab(tab);
      }
    });
  }

  closeTab(tab: MyTabComponent) {
    this.showContextMenu = false;
    clearTimeout(this.hoverTimeout);
    this.showHoverTitle = false;
    if (tab.changeForm) {
      this.selectTab(tab);
      this.klSweetAlert.alert(
        {
          title: "Uyarı",
          text: "Kapatmak istediğiniz sekmede kaydedilmemiş veriler var. Kapatmak istiyor musunuz?",
        },
        () => {
          this.close(tab);
          if (this.stopDeleting) {
            this.continueCloseTab();
          }
        },
        () => {}
      );
    } else {
      this.close(tab);
    }
  }

  close(tab: MyTabComponent) {
    for (let i = 0; i < this.dynamicTabs.length; i++) {
      if (this.dynamicTabs[i] === tab) {
        // remove the tab from our array
        this.dynamicTabs.splice(i, 1);

        // destroy our dynamically created components again
        const viewContainerRef = this.dynamicTabPlaceholder;
        // let viewContainerRef = this.dynamicTabPlaceholder;
        viewContainerRef.remove(i);

        // set tab index to 1st one
        // get the count of created dynamic tabs
        const countOfDynamicTabs = this.dynamicTabs.length;
        // define the last dynamic tabs
        if (i === countOfDynamicTabs) {
          if (countOfDynamicTabs === 0) {
            this.selectTab(this.tabs.last);
          } else {
            this.selectTab(this.dynamicTabs[i - 1]);
          }
        } else {
          if (tab.tabId === this.activeTab.tabId) {
            if (countOfDynamicTabs === 0) {
              this.selectTab(this.tabs.last);
            } else {
              this.selectTab(this.dynamicTabs[i]);
            }
          } else {
            if (countOfDynamicTabs === 0) {
              this.selectTab(this.tabs.last);
            } else {
              this.selectTab(this.activeTab);
            }
          }
        }
        break;
      }
    }
  }

  checkChangedFormCount() {
    let count = 0;
    let forms = "";
    for (let i = 0; i < this.dynamicTabs.length; i++) {
      if (this.dynamicTabs[i].changeForm) {
        count = count + 1;
        if (
          !forms.includes(
            this.translateService.instant(this.dynamicTabs[i].title)
          )
        ) {
          forms +=
            this.translateService.instant(this.dynamicTabs[i].title) + ", ";
        }
      }
    }
    if (count === 0) {
      this.closeAllTab();
    } else {
      forms = forms.slice(0, forms.length - 2);
      this.klSweetAlert.alert(
        {
          title: "Uyarı",
          text:
            forms +
            (count > 1 ? " ekranlarında" : " ekranında") +
            " kaydedilmemiş veriler var. Şirketi ve Çalışma Dönemini değiştirmek istiyor musunuz?",
        },
        () => {
          this.closeAllTab();
        },
        () => {}
      );
    }
  }

  continueCloseTab() {
    this.stopDeleting = false;
    switch (this.closeType) {
      case "ALL":
        this.closeAllTab();
        break;
      case "OTHERS":
        if (this.mustClosedTabCount > 0) {
          this.closeOtherTabs();
        }
        break;
      case "LEFT":
        if (this.mustClosedTabCount > 0) {
          this.closeTabsToTheLeft();
        }
        break;
      case "RIGHT":
        if (this.mustClosedTabCount > 0) {
          this.closeTabsToTheRight();
        }
        break;
    }
  }

  closeAllTab() {
    this.showContextMenu = false;
    this.currentTabIndex = null;
    this.closeType = "ALL";
    this.tabCountBeforeClosing = this.dynamicTabs.length;
    for (let i = this.dynamicTabs.length - 1; i >= 0; i--) {
      if (this.dynamicTabs[i].changeForm) {
        this.deletingTabCount = this.tabCountBeforeClosing - i;
        this.stopDeleting = true;
        this.closeTab(this.dynamicTabs[i]);
        this.mustClosedTabCount = this.dynamicTabs.length;
        break;
      } else {
        this.closeTab(this.dynamicTabs[i]);
      }
    }
  }

  closeOtherTabs() {
    this.closeType = "OTHERS";
    this.showContextMenu = false;
    let continueDeleting = true;
    let closedTab = 0;
    this.tabCountBeforeClosing = this.dynamicTabs.length;
    for (let i = this.currentTabIndex - 1; i >= 0; i--) {
      if (this.dynamicTabs[i].changeForm) {
        this.deletingTabCount = this.tabCountBeforeClosing - i;
        this.stopDeleting = true;
        this.closeTab(this.dynamicTabs[i]);
        continueDeleting = false;
        this.currentTabIndex = this.currentTabIndex - closedTab;
        this.mustClosedTabCount = this.currentTabIndex;
        break;
      } else {
        this.closeTab(this.dynamicTabs[i]);
        closedTab = closedTab + 1;
      }
    }
    if (continueDeleting) {
      this.tabCountBeforeClosing = this.dynamicTabs.length;
      for (let i = this.dynamicTabs.length - 1; i > 0; i--) {
        if (this.dynamicTabs[i].changeForm) {
          this.deletingTabCount = this.tabCountBeforeClosing - i;
          this.stopDeleting = true;
          this.closeTab(this.dynamicTabs[i]);
          this.mustClosedTabCount = this.dynamicTabs.length - 1;
          break;
        } else {
          this.closeTab(this.dynamicTabs[i]);
        }
      }
    }
  }

  closeTabsToTheLeft() {
    this.closeType = "LEFT";
    this.showContextMenu = false;
    let closedTab = 0;
    this.tabCountBeforeClosing = this.dynamicTabs.length;
    for (let i = this.currentTabIndex - 1; i >= 0; i--) {
      if (this.dynamicTabs[i].changeForm) {
        this.deletingTabCount = this.tabCountBeforeClosing - i;
        this.stopDeleting = true;
        this.closeTab(this.dynamicTabs[i]);
        this.currentTabIndex = this.currentTabIndex - closedTab;
        this.mustClosedTabCount = this.currentTabIndex;
        break;
      } else {
        this.closeTab(this.dynamicTabs[i]);
        closedTab = closedTab + 1;
      }
    }
    let hasActiveTab = false;
    this.dynamicTabs.forEach((tab) => {
      if (tab.active) {
        hasActiveTab = true;
      }
    });
    if (!hasActiveTab) {
      this.selectTab(this.dynamicTabs[0]);
    }
  }

  closeTabsToTheRight() {
    this.closeType = "RIGHT";
    this.showContextMenu = false;
    this.tabCountBeforeClosing = this.dynamicTabs.length;
    for (let i = this.dynamicTabs.length - 1; i > this.currentTabIndex; i--) {
      if (this.dynamicTabs[i].changeForm) {
        this.deletingTabCount = this.tabCountBeforeClosing - i;
        this.stopDeleting = true;
        this.closeTab(this.dynamicTabs[i]);
        this.mustClosedTabCount =
          this.dynamicTabs.length - this.currentTabIndex - 1;
        break;
      } else {
        this.closeTab(this.dynamicTabs[i]);
      }
    }
    let hasActiveTab = false;
    this.dynamicTabs.forEach((tab) => {
      if (tab.active) {
        hasActiveTab = true;
      }
    });
    if (!hasActiveTab) {
      this.selectTab(this.dynamicTabs[this.dynamicTabs.length - 1]);
    }
  }

  @HostListener("window:resize", ["$event"]) onResize() {
    this.layoutTabs();
  }

  emit(eventName, data) {
    this.chromeElement.dispatchEvent(
      new CustomEvent(eventName, { detail: data })
    );
  }

  setupCustomProperties() {
    this.chromeElement.style.setProperty(
      "--tab-content-margin",
      `${this.TAB_CONTENT_MARGIN}px`
    );
  }

  setupStyleEl() {
    this.styleEl = document.createElement("style");
    this.chromeElement.appendChild(this.styleEl);
  }

  get tabElements() {
    return Array.prototype.slice.call(
      this.chromeElement.querySelectorAll(".chrome-tab")
    );
  }

  get tabContentEl() {
    return this.chromeElement.querySelector(".chrome-tabs-content");
  }

  get tabContentWidths() {
    const numberOfTabs = this.tabElements.length;
    const tabsContentWidth = this.tabContentEl.clientWidth;
    const tabsCumulativeOverlappedWidth =
      (numberOfTabs - 1) * this.TAB_CONTENT_OVERLAP_DISTANCE;
    const targetWidth =
      (tabsContentWidth -
        2 * this.TAB_CONTENT_MARGIN +
        tabsCumulativeOverlappedWidth) /
      numberOfTabs;
    const clampedTargetWidth = Math.max(
      this.TAB_CONTENT_MIN_WIDTH,
      Math.min(this.TAB_CONTENT_MAX_WIDTH, targetWidth)
    );
    const flooredClampedTargetWidth = Math.floor(clampedTargetWidth);
    const totalTabsWidthUsingTarget =
      flooredClampedTargetWidth * numberOfTabs +
      2 * this.TAB_CONTENT_MARGIN -
      tabsCumulativeOverlappedWidth;
    const totalExtraWidthDueToFlooring =
      tabsContentWidth - totalTabsWidthUsingTarget;

    // TODO - Support tabs with different widths / e.g. "pinned" tabs
    const widths = [];
    let extraWidthRemaining = totalExtraWidthDueToFlooring;
    for (let i = 0; i < numberOfTabs; i += 1) {
      const extraWidth =
        flooredClampedTargetWidth < this.TAB_CONTENT_MAX_WIDTH &&
        extraWidthRemaining > 0
          ? 1
          : 0;
      widths.push(flooredClampedTargetWidth + extraWidth);
      if (extraWidthRemaining > 0) {
        extraWidthRemaining -= 1;
      }
    }

    return widths;
  }

  get tabContentPositions() {
    const positions = [];
    const tabContentWidths = this.tabContentWidths;

    let position = this.TAB_CONTENT_MARGIN;
    tabContentWidths.forEach((width, i) => {
      const offset = i * this.TAB_CONTENT_OVERLAP_DISTANCE;
      positions.push(position - offset);
      position += width;
    });

    return positions;
  }

  get tabPositions() {
    const positions = [];

    this.tabContentPositions.forEach((contentPosition) => {
      positions.push(contentPosition - this.TAB_CONTENT_MARGIN);
    });

    return positions;
  }

  layoutTabs() {
    const tabContentWidths = this.tabContentWidths;

    this.tabElements.forEach((tabEl, i) => {
      const contentWidth = tabContentWidths[i];
      const width = contentWidth + 2 * this.TAB_CONTENT_MARGIN;

      tabEl.style.width = width + "px";
      tabEl.removeAttribute("is-small");
      tabEl.removeAttribute("is-smaller");
      tabEl.removeAttribute("is-mini");

      if (contentWidth < this.TAB_SIZE_SMALL) {
        tabEl.setAttribute("is-small", "");
      }
      if (contentWidth < this.TAB_SIZE_SMALLER) {
        tabEl.setAttribute("is-smaller", "");
      }
      if (contentWidth < this.TAB_SIZE_MINI) {
        tabEl.setAttribute("is-mini", "");
      }
    });

    let styleHTML = "";
    this.tabPositions.forEach((position, i) => {
      styleHTML += `
          .chrome-tabs[data-chrome-tabs-instance-id="0"] .chrome-tab:nth-child(${
            i + 1
          }) {
            transform: translate3d(${position}px, 0, 0)
          }
        `;
    });
    this.styleEl.innerHTML = styleHTML;
  }

  addTab(tabId) {
    const tabEl = document.getElementById(tabId);
    if (tabEl) {
      tabEl.classList.add("chrome-tab-was-just-added");
      setTimeout(
        () => tabEl.classList.remove("chrome-tab-was-just-added"),
        300
      );
      // this.tabContentEl.appendChild(tabEl);
      this.emit("tabAdd", { tabEl });
    }
    this.setCurrentTab(tabEl);
    this.cleanUpPreviouslyDraggedTabs();
    this.layoutTabs();
    this.setupDraggabilly();
  }

  get activeTabEl() {
    return this.chromeElement.querySelector(".chrome-tab[active]");
  }

  setCurrentTab(tabEl) {
    const activeTabEl = this.activeTabEl;
    if (activeTabEl === tabEl) {
      return;
    }
    if (activeTabEl) {
      activeTabEl.removeAttribute("active");
    }
    if (tabEl) {
      tabEl.setAttribute("active", "");
    }
    this.emit("activeTabChange", { tabEl });
  }

  cleanUpPreviouslyDraggedTabs() {
    this.tabElements.forEach((tabEl) =>
      tabEl.classList.remove("chrome-tab-was-just-dragged")
    );
  }

  setupDraggabilly() {
    const tabElements = this.tabElements;
    const tabPositions = this.tabPositions;

    if (this.isDragging) {
      this.isDragging = false;
      this.chromeElement.classList.remove("chrome-tabs-is-sorting");
      this.draggabillyDragging.element.classList.remove(
        "chrome-tab-is-dragging"
      );
      this.draggabillyDragging.element.style.transform = "";
      this.draggabillyDragging.dragEnd();
      this.draggabillyDragging.isDragging = false;
      this.draggabillyDragging.positionDrag = this.noop; // Prevent Draggabilly from updating tabEl.style.transform in later frames
      this.draggabillyDragging.destroy();
      this.draggabillyDragging = null;
    }

    this.draggabillyInstances.forEach((draggabillyInstance) =>
      draggabillyInstance.destroy()
    );

    tabElements.forEach((tabEl, originalIndex) => {
      const currentTab = this.dynamicTabs.find((tab) => tab.tabId === tabEl.id);
      const originalTabPositionX = tabPositions[originalIndex];
      const draggabillyInstance = new Draggabilly(tabEl, {
        axis: "x",
        handle: ".chrome-tab-drag-handle",
        containment: this.tabContentEl,
      });

      this.draggabillyInstances.push(draggabillyInstance);

      draggabillyInstance.on("pointerDown", () => {
        this.setCurrentTab(tabEl);
      });

      draggabillyInstance.on("dragStart", () => {
        this.isDragging = true;
        this.showContextMenu = false;
        this.draggabillyDragging = draggabillyInstance;
        tabEl.classList.add("chrome-tab-is-dragging");
        this.chromeElement.classList.add("chrome-tabs-is-sorting");
        if (tabEl.id) {
          this.selectTab(currentTab);
        }
      });

      draggabillyInstance.on("dragEnd", () => {
        this.isDragging = false;
        const finalTranslateX = parseFloat(tabEl.style.left);
        tabEl.style.transform = `translate3d(0, 0, 0)`;

        // Animate dragged tab back into its place
        requestAnimationFrame(() => {
          tabEl.style.left = "0";
          tabEl.style.transform = `translate3d(${finalTranslateX}px, 0, 0)`;

          requestAnimationFrame(() => {
            tabEl.classList.remove("chrome-tab-is-dragging");
            this.chromeElement.classList.remove("chrome-tabs-is-sorting");

            tabEl.classList.add("chrome-tab-was-just-dragged");

            requestAnimationFrame(() => {
              tabEl.style.transform = "";

              this.layoutTabs();
              this.setupDraggabilly();
            });
          });
        });
        setTimeout(() => {
          const emptyTabElementIndex = findIndex(this.tabElements, { id: "" });
          let tabElementIndex = findIndex(this.tabElements, { id: tabEl.id });
          const dynamicTabIndex = findIndex(this.dynamicTabs, {
            tabId: tabEl.id,
          });
          if (dynamicTabIndex !== -1 && tabElementIndex !== -1) {
            if (tabElementIndex > emptyTabElementIndex) {
              tabElementIndex = tabElementIndex - 1;
            }
            this.dynamicTabs = MyTabsComponent.dynamicTabIndexChange(
              this.dynamicTabs,
              dynamicTabIndex,
              tabElementIndex
            );
          }
        }, 5);
      });

      draggabillyInstance.on("dragMove", (event, pointer, moveVector) => {
        // Current index be computed within the event since it can change during the dragMove
        const tabEls = this.tabElements;
        const currentIndex = tabEls.indexOf(tabEl);

        const currentTabPositionX = originalTabPositionX + moveVector.x;
        const destinationIndexTarget = this.closest(
          currentTabPositionX,
          tabPositions
        );
        const destinationIndex = Math.max(
          0,
          Math.min(tabEls.length, destinationIndexTarget)
        );

        if (currentIndex !== destinationIndex) {
          this.animateTabMove(tabEl, currentIndex, destinationIndex);
        }
      });
    });
  }

  animateTabMove(tabEl, originIndex, destinationIndex) {
    if (destinationIndex < originIndex) {
      tabEl.parentNode.insertBefore(tabEl, this.tabElements[destinationIndex]);
    } else {
      tabEl.parentNode.insertBefore(
        tabEl,
        this.tabElements[destinationIndex + 1]
      );
    }
    this.emit("tabReorder", { tabEl, originIndex, destinationIndex });
    this.layoutTabs();
  }
}
